import http from '../http-common';

class ReligionCategoryDataService {
  getAll() {
    return http.get("/category");
  }

  get(id) {
    return http.get(`/category/edit/${id}`);
  }

  create(data) {
    return http.post("/category/add", data);
  }

  update(id, data) {
    return http.put(`/category/update/${id}`, data);
  }

  
  delete(id) {
    return http.put(`/category/delete/${id}`);
  }
}

export default new ReligionCategoryDataService();
